import { render } from "./SelectYear.vue?vue&type=template&id=23d14b82"
import script from "./SelectYear.vue?vue&type=script&lang=js"
export * from "./SelectYear.vue?vue&type=script&lang=js"
script.render = render

export default script